import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class MarketAnalysisService {

  private uri = `${environment.apiUrl}`;

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.uri = this.appConfigService.apiBaseUrl;
  }

  GetForecastURL() {
    return this.uri + '/Forecast';
  }

  GetMarketAnalysisRegions() {
    return this.http.post<any>(this.uri + '/MarketAnalysis/GetMarketAnalysisRegions', {} );
  }

  GetMarketAnalysisClientCompetitors() {
    return this.http.post<any>(this.uri + '/MarketAnalysis/GetMarketAnalysisClientCompetitors', {} );
  }

  SaveMarketAnalysisClientCompetitors(form) {
    return this.http.post<any>(this.uri + '/MarketAnalysis/InsertMarketAnalysisCompetitos', form );
  }

  SaveMarketAnalysisRegions(form) {
    return this.http.post<any>(this.uri + '/MarketAnalysis/InsertMarketAnalysisRegions', form );
  }

}
